import _ from 'lodash';
import moment from 'moment-timezone';
import Signals from 'signals';
import PreferenceService from '../../services/preference.service';

const DATE_RANGE_KEY = 'DATE_RANGE';
const prefApps = ['historical2', 'rooms'];
const sessionStorageApps = ['admin', 'assurance'];
const defaultPrefsByApp = {
    'historical2': {
        startDate: moment().subtract(1, 'month').startOf('month'),
        endDate: moment().subtract(1, 'month').endOf('month'),
        rangeLabel: 'Last Hour',
    },
    'rooms': {
        startDate: moment().subtract(1, 'month').startOf('month'),
        endDate: moment().subtract(1, 'month').endOf('month'),
        rangeLabel: 'Last Hour',
    },
    'assurance': {
        startDate: moment().subtract(1, 'hours'),
        endDate: moment(),
        rangeLabel: 'Last Hour',
    },
    'admin': {
        startDate: moment().subtract(1, 'hours'),
        endDate: moment(),
        rangeLabel: 'Last Hour',
    }
};
function DateRangeModel(appId) {
    var self = this;
    self.appId = appId;
    self.availableRanges = null;
    self.liveModeStatus = null;
    let storedPrefs;
    if (prefApps.indexOf(self.appId) === -1) {
        storedPrefs = getLocalPrefs();
    } else {
        storedPrefs = PreferenceService.getDateRange(appId).then((range) => this.setCurrentRange(range));
    }
    self.currentRange = {
        startDate: storedPrefs.startDate ? moment(storedPrefs.startDate) : defaultPrefsByApp[self.appId].startDate,
        endDate: storedPrefs.endDate ? moment(storedPrefs.endDate) : defaultPrefsByApp[self.appId].endDate,
        rangeLabel: storedPrefs.rangeLabel ? storedPrefs.rangeLabel : defaultPrefsByApp[self.appId].rangeLabel,
        status: storedPrefs.status,
    };
    self.liveModeStatus = storedPrefs.status !== undefined ? storedPrefs.status : (prefApps.indexOf(self.appId) === -1);

    //  TODO - change 'signals' to "simple" observables as in 'observable-factory.ts'
    self.availableRangesUpdated = new Signals.Signal();
    self.currentRangeUpdated = new Signals.Signal();
    self.liveModeStatusUpdated = new Signals.Signal();
}

DateRangeModel.defaultFormat = 'MMM D, YYYY';

DateRangeModel.prototype = {
    getAvailableRanges: function () {
        var self = this;
        return _.cloneDeep(self.availableRanges);
    },

    getCurrentRange: function () {
        var self = this;
        return _.cloneDeep(self.currentRange);
    },

    getLiveModeStatus: function () {
        var self = this;
        return _.cloneDeep(self.liveModeStatus);
    },

    setAvailableRanges: function (ranges) {
        var self = this;
        self.availableRanges = _.cloneDeep(ranges);
        self.availableRangesUpdated.dispatch();
    },

    setCurrentRange: function (range) {
        var self = this;
        self.currentRange = {
            startDate: moment(range.startDate),
            endDate: moment(range.endDate),
            rangeLabel: range.rangeLabel,
        };
        if (prefApps.indexOf(self.appId) === -1) {
            saveLocalPrefs(Object.assign({status: self.liveModeStatus}, self.currentRange));
        } else {
            PreferenceService.saveDateRange(self.appId, self.currentRange);
        }
        self.currentRangeUpdated.dispatch();
    },

    setLiveModeStatus: function (status) {
        var self = this;
        self.liveModeStatus = _.cloneDeep(status);
        self.currentRange.status = self.liveModeStatus;
        if (prefApps.indexOf(self.appId) === -1) {
            saveLocalPrefs(self.currentRange);
        // } else {
        //     PreferenceService.saveDateRange(self.appId, self.currentRange);
        }
        self.liveModeStatusUpdated.dispatch();
    }
};

function getLocalPrefs() {
    return JSON.parse(sessionStorage.getItem(DATE_RANGE_KEY))
        || {
            startDate: moment().subtract(1, 'hour'),
            endDate: moment()
        };
}

function saveLocalPrefs(data) {
    sessionStorage.setItem(DATE_RANGE_KEY, JSON.stringify(data
        || {
            startDate: moment().subtract(1, 'hour'),
            endDate: moment()
        }));
}

export default DateRangeModel;
